import { CountryCode, CurrencyCode } from '@dayetopia/types';
import { CurrencyObj } from '@contracts';

/**
 * Gets the currency code for a given country code.
 *
 * @param {CountryCode} countryCode - The country code to get the currency code for.
 * @returns {CurrencyCode} The currency code for the given country code.
 */
export function getCurrencyFromCountryCode(countryCode: CountryCode): CurrencyCode {
  switch (countryCode) {
    case CountryCode.GB:
      return CurrencyCode.GBP;
    case CountryCode.US:
      return CurrencyCode.USD;
    case CountryCode.BG:
      return CurrencyCode.BGN;
    default:
      return CurrencyCode.EUR;
  }
}

/**
 * Gets the currency object for a given currency code.
 *
 * @param {CurrencyCode} currencyCode - The currency code to get the currency object for.
 * @returns {CurrencyObj} The currency object for the given currency code.
 */
export function getCurrencyFromCurrencyCode(currencyCode: CurrencyCode): CurrencyObj {
  switch (currencyCode) {
    case CurrencyCode.GBP:
      return {
        letterCode: CurrencyCode.GBP,
        symbol: '£'
      };
    case CurrencyCode.USD:
      return {
        letterCode: CurrencyCode.USD,
        symbol: '$'
      };
    case CurrencyCode.BGN:
      return {
        letterCode: CurrencyCode.BGN,
        symbol: 'лв'
      };
    default:
      return {
        letterCode: CurrencyCode.EUR,
        symbol: '€'
      };
  }
}
